import { AuxRoute } from './aux-route.model';

/**
* The configuration of a route template
*/
export class RouteConfiguration {

    /**
     * The nam of a route configuration
     */
    public name: string;
    /**
     * The routes used in the route configuration
     */
    public routes: AuxRoute[];

    public isNonAuxRoute: boolean;
}
